/** @format */

// This module runs in the partner site so we can crawl their settings
import Postmate from "@regily/regily-postmate";
import { PARTNER_MESSAGES } from "./constants";
import { getDynamicSettings } from "../utils/browserStructure";
import { getExtendedExistingConnection } from "../partners/appModeHelpers";

const connectionModel = {
  [PARTNER_MESSAGES.GET_SETTINGS]: () => {
    return getDynamicSettings();
  },
};

export const stablishConnection = async () => {
  try {
    const childConnection =
      getExtendedExistingConnection(connectionModel) ||
      (await new Postmate.Model(connectionModel));
    return childConnection;
  } catch (err) {
    console.error("Partner site - Error while connecting", err);
  }
};

// This one runs within the partner page
export const runPartnerCrawler = async () => {
  const childConnection = await stablishConnection();
  return childConnection;
};



// WEBPACK FOOTER //
// ./src/crawler/partnerCrawler.js